
import { apiBaseUrl } from './constants'
// import moment from 'moment'

function getHeaders () {
  return new Headers({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('user-store-token')}`
  })
}

export default {
  reportsLogin ({ loginId, password }) {
    return fetch(`${apiBaseUrl}/auth/user`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({
        username: loginId,
        password
      })
    })
    .then(resp => resp.json()
      // (res) => {
      // resp => resp.json()
      // debugger
      // console.log(res.status
      // return fetch(`${apiBaseUrl}/user/donation/from/${+(moment().startOf('week')._d)}/to/${+(moment().endOf('week')._d)}`, {
      //   method: 'GET',
      //   headers: getHeaders()
      // })
      // .then(resp => resp.json())
    )
  },
  getReports (range) {
    return fetch(`${apiBaseUrl}/user/donation/from/${range.from}/to/${range.to}`, {
      method: 'GET',
      headers: getHeaders()
    })
    .then(resp => resp.json())
  },
  getEndOfDayReports (range) {
    return fetch(`${apiBaseUrl}/user/eod-report/from/${range.from}/to/${range.to}`, {
      method: 'GET',
      headers: getHeaders()
    })
    .then(resp => resp.json())
  },
  createEndOfDayReports ({tid, reports}) {
    return fetch(`${apiBaseUrl}/user/eod-report/${tid}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({
        'eod_report': reports
      })
    })
    .then(resp => resp.json())
  }
}



// WEBPACK FOOTER //
// ./src/api/reports.js